import { useRef } from "react";
import { Button, Progress } from "antd";
import PropTypes from "prop-types";

import Resources from "scripts/resources";

const Component = ({ countdown, percent, submitting, onChange, onResend }) => {
	const pattern = "[0-9]{1}";
	const inputsRef = useRef([]);

	const handleResult = () => {
		const res = inputsRef.current.map((input) => input.value).join("");

		onChange(res);
	};

	const handleFocus = (e) => {
		e.target.select();
	};

	const handleChange = (e) => {
		const {
			target: { value, nextElementSibling },
		} = e;

		if (value.length > 1) {
			e.target.value = value.charAt(0);

			if (nextElementSibling !== null) nextElementSibling.focus();
		} else {
			if (value.match(pattern)) {
				if (nextElementSibling !== null) nextElementSibling.focus();
			} else {
				e.target.value = "";
			}
		}

		handleResult();
	};

	const handleKeyDown = (e) => {
		const {
			key,
			target: { value, previousElementSibling },
		} = e;

		if (key === "Backspace") {
			if (value === "") {
				if (previousElementSibling !== null) {
					const t = previousElementSibling;
					t.value = "";
					t.focus();
					e.preventDefault();
				}
			} else {
				e.target.value = "";
			}

			handleResult();
		}
	};

	const handlePaste = (e) => {
		const pastedValue = e.clipboardData.getData("Text");

		let currentInput = 0;

		for (let i = 0; i < pastedValue.length; i++) {
			const pastedCharacter = pastedValue.charAt(i);
			const currentValue = inputsRef.current[currentInput].value;

			if (pastedCharacter.match(pattern)) {
				if (!currentValue) {
					inputsRef.current[currentInput].value = pastedCharacter;

					if (
						inputsRef.current[currentInput].nextElementSibling !== null
					) {
						inputsRef.current[currentInput].nextElementSibling.focus();
						currentInput++;
					}
				}
			}
		}

		handleResult();

		e.preventDefault();
	};

	return (
		<div className="bk-input-code">
			<div className="group">
				<input
					type="tel"
					onKeyDown={handleKeyDown}
					onChange={handleChange}
					onFocus={handleFocus}
					onPaste={handlePaste}
					ref={(el) => (inputsRef.current[0] = el)}
					className="ant-input ant-input-lg ant-input-rtl"
					autoComplete="off"
				/>
				<input
					type="tel"
					onKeyDown={handleKeyDown}
					onChange={handleChange}
					onFocus={handleFocus}
					onPaste={handlePaste}
					ref={(el) => (inputsRef.current[1] = el)}
					className="ant-input ant-input-lg ant-input-rtl"
					autoComplete="off"
				/>
				<input
					type="tel"
					onKeyDown={handleKeyDown}
					onChange={handleChange}
					onFocus={handleFocus}
					onPaste={handlePaste}
					ref={(el) => (inputsRef.current[2] = el)}
					className="ant-input ant-input-lg ant-input-rtl"
					autoComplete="off"
				/>
				<input
					type="tel"
					onKeyDown={handleKeyDown}
					onChange={handleChange}
					onFocus={handleFocus}
					onPaste={handlePaste}
					ref={(el) => (inputsRef.current[3] = el)}
					className="ant-input ant-input-lg ant-input-rtl"
					autoComplete="off"
				/>
				<input
					type="tel"
					onKeyDown={handleKeyDown}
					onChange={handleChange}
					onFocus={handleFocus}
					onPaste={handlePaste}
					ref={(el) => (inputsRef.current[4] = el)}
					className="ant-input ant-input-lg ant-input-rtl"
					autoComplete="off"
				/>
			</div>
			<Button
				className="btn"
				type="link"
				icon={
					countdown > 0 && (
						<Progress
							type="circle"
							width={26}
							percent={percent}
							format={(percent) => countdown}
						/>
					)
				}
				disabled={countdown > 0}
				onClick={onResend}
			>
				{Resources.resend}
			</Button>
		</div>
	);
};

Component.propTypes = {
	countdown: PropTypes.number,
	percent: PropTypes.number,
	onChange: PropTypes.func,
	onResend: PropTypes.func.isRequired,
	submitting: PropTypes.bool,
};

export default Component;
